export default {"src":"/_next/static/media/pivx.78f14fb1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};